"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createStoreWithArgs;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _redux = require("redux");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _logOnlyInProduction = require("redux-devtools-extension/logOnlyInProduction");

var _sagas = _interopRequireDefault(require("../sagas"));

var reducers = _interopRequireWildcard(require("../reducers"));

var _reduxBeacon = _interopRequireDefault(require("../middlewares/reduxBeacon"));

function createStoreWithArgs(modules, appSpecificModules) {
  var sagaMiddleware = (0, _reduxSaga["default"])();
  var rootReducer = (0, _redux.combineReducers)((0, _objectSpread3["default"])({}, modules.reduce(function (reducer, module) {
    return (0, _objectSpread3["default"])({}, reducer, (0, _defineProperty2["default"])({}, module, reducers[module]));
  }, {}), appSpecificModules));
  var composeEnhancers = (0, _logOnlyInProduction.composeWithDevTools)({// options like actionSanitizer, stateSanitizer
  });
  var store = (0, _redux.createStore)(rootReducer, composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware, _reduxBeacon["default"])));
  sagaMiddleware.run(_sagas["default"]);
  return store;
}